import Axios, { InternalAxiosRequestConfig } from 'axios'
import GlobalStore from 'src/stores/GlobalStore'
import NotificationStore from 'src/stores/NotificationStore'

const ServiceBase = {
  attachAuthInterceptor,
  attachResponseInterceptor,
}

export default ServiceBase

function attachAuthInterceptor(): void {
  Axios.interceptors.request.use(async (config: InternalAxiosRequestConfig) => {
    config.withCredentials = true
    return config
  })
}

function attachResponseInterceptor(
  global: GlobalStore,
  notifications: NotificationStore
): void {
  Axios.interceptors.response.use(undefined, (err) => {
    if (err.config?.skipErrorNotification) {
      return Promise.reject(err)
    }

    const response = err.response
    if (!response) {
      notifications.sendNotification(
        err.config?.url ?? 'Request failed',
        err.message || 'The request failed before a response was received.',
        { variant: 'error' }
      )
      return Promise.reject(err)
    }

    const data = response.data
    if (response.status === 401) {
      global.clearUserAndRouteToLogin()
      notifications.sendNotification(
        '401',
        data === '' ? 'Session has ended. Please login.' : data,
        {
          variant: 'error',
        }
      )
    } else if (data === '') {
      notifications.sendNotification(
        response.url,
        'An error has occurred: ' + response.statusText,
        { variant: 'error' }
      )
    } else {
      const errorMessage =
        typeof data === 'string' ? data : data?.message || 'An error has occurred'
      notifications.sendNotification(response.url, errorMessage, { variant: 'error' })
    }
    return Promise.reject(response)
  })
}
